import React from 'react';
import "./style.css";

const DisplayBtn = (props) => {
	return <button type="button" className={'display-btn ' + props.condition} onClick={props.clicked}>Display {props.condition}</button>
};

export default DisplayBtn;